import { gql } from "@outschool/ui-apollo";

export const classRecordingStatusQuery = gql`
  query ClassRecordingStatus($recordingUid: ID!, $sectionUid: ID!) {
    section(uid: $sectionUid) {
      uid
      classRecording(recordingUid: $recordingUid) {
        uid
        playUrl
        ... on ClassRecording {
          readyToPlay
          isExpired
          speakingTimes {
            learnerSpeaker {
              uid
            }
            educatorSpeaker {
              uid
            }
            speakingTimeMarkers {
              time
              duration
              speakerName
            }
          }
        }
      }
    }
  }
`;
